import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { UnpairingReason } from '../../../types/UnpairingReason';

export interface UnpairInput {
  unpairReasons: number[];
}

export interface UnpairProps {
  formRef: FormikProps<UnpairInput>; // Adjust the form values accordingly
  unpairingReasons: UnpairingReason[]; // Dynamic array of unpairing reasons
}

export default function UnpairForm(props: UnpairProps) {
  return (
    <Box component='form' onSubmit={props.formRef.handleSubmit}>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        Select at least one reason for unpairing.
      </Typography>
      <FormGroup sx={{ rowGap: 0.5 }}>
        {props.unpairingReasons.map((reason) => (
          <FormControlLabel
            key={reason.reason}
            control={
              <Checkbox
                size='small'
                checked={props.formRef.values.unpairReasons.includes(reason.reason)}
                disabled={!reason.isSelectable}
                onChange={() => {
                  const updatedReasons = props.formRef.values.unpairReasons.includes(reason.reason)
                    ? props.formRef.values.unpairReasons.filter((value: number) => value !== reason.reason)
                    : [...props.formRef.values.unpairReasons, reason.reason];

                  props.formRef.setFieldValue('unpairReasons', updatedReasons);
                }}
              />
            }
            label={reason.label}
          />
        ))}
      </FormGroup>
    </Box>
  );
}
